import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { WorkStationsForCategoryResponse, WorkStationsListDto, WorkStationsListResponseModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { WorkstationDTO } from './dto/workstation.dto';
import { WorkstationAdapter } from './dto/workstation.adapter';
import { WorkstationResponseModel, AllWorkstationResponseModel, CommonResponse } from '@gtpl/shared-models/production-management';
import { WorkstationRequest } from './dto/workstation.request';
import { WorkStations } from './workstations.entity'
import { WorkStationCategoryRequest } from './dto/work-station-category.request';
import { WorkStationsRepository } from './repository/workstation-repository';
import { UnitRequest } from '../operations-track/dto/unit.id.request';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import appSettings from 'apps/services/config';

@Injectable()
export class WorkstationsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(WorkStationsRepository)
        private workStationRepo: WorkStationsRepository,
        private workstationAdapter: WorkstationAdapter) { }

    /**
   * 
   * @param workstationDTO 
   * @param isUpdate 
   * @param request 
   * @returns 
   */
    async createWorkstation(workstationDTO: WorkstationDTO, isUpdate: boolean, request: Request): Promise<WorkstationResponseModel> {
        try {
            console.log(isUpdate);
            // to check whether Workstation  exists with the passed name  or not. if isUpdate is false, a check will be done whether a record with the passed Workstation  is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Workstation  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const WorkstationEntity = await this.getWorkstationDetailsWithoutRelations(workstationDTO.workstation);
                if (WorkstationEntity) {
                    throw new WorkstationResponseModel(false,11104, 'Workstation  already exists');
                }
                // var notificationStatus='Created';
            } else {
                const WorkstationEntity = await this.getWorkstationDetailsWithoutRelations(workstationDTO.workstation);
                if (WorkstationEntity)  {
                    if (WorkstationEntity.workstationId != workstationDTO.workstationId) {
                        throw new WorkstationResponseModel(false,11104, 'Workstation  already exists');
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedWorkstationEntity: WorkStations = this.workstationAdapter.convertDtoToEntity(workstationDTO, isUpdate);
            const savedWorkstationEntity: WorkStations = await this.workStationRepo.save(
                convertedWorkstationEntity
            );
            const savedWorkstationDto: WorkstationDTO = this.workstationAdapter.convertEntityToDto(savedWorkstationEntity);
            if (savedWorkstationDto) {
                // generating resposnse
                const response = new WorkstationResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Workstation  Updated Successfully' : 'Workstation  Created Successfully', savedWorkstationDto);
            //     const name=isUpdate?'updated':'created'
            // const newLogDto = new LogsDto(1,name, 'WorkStations', savedWorkstationDto.workstationId, true, '',savedWorkstationDto.createdUser)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
                return response;
            } else {
                throw new WorkstationResponseModel(false,11106, 'Workstation  saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }

    async getWorkstationDetailsWithoutRelations(workstation: string): Promise<WorkStations> {
        // tslint:disable-next-line: typedef
        const workstationResponse = await this.workStationRepo.findOne({
            where: { workstation: Raw(alias => `workstation= '${workstation}'`) },
        });
        if (workstationResponse) {
            return workstationResponse;
        } else {
            return null;
        }
    }


    /**
   * 
   * @returns AllWorkstationResponseModel
   */
    async getAllWorkstation(req: UnitRequest): Promise<AllWorkstationResponseModel> {
        // const page: number = 1;
        const workstationDTO: WorkstationDTO[] = [];
        //retrieves all companies
        const workstationEntities: WorkStations[] = await this.workStationRepo.find({ where: { unitId: req.unitId }, relations: ['workstationCategoryInfo'], order: { 'workstation': 'ASC' } });
        console.log(workstationEntities);
        if (workstationEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            workstationEntities.forEach(workstationEntity => {
                const convertedstatesDto: WorkstationDTO = this.workstationAdapter.convertEntityToDto(
                    workstationEntity
                );
                workstationDTO.push(convertedstatesDto);
            });
            console.log(workstationDTO);
            const response = new AllWorkstationResponseModel(true, 11108, "Workstation retrieved successfully", workstationDTO);
            
            // const newLogDto = new LogsDto(1,'view', 'WorkStations', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return response;
        } else {
            throw new WorkstationResponseModel(false,99998, 'Data not found');
        }

    }

    /**
    * @param workstationReq 
    * @returns 
    */
   
    async activateorDeactivateWorkstation(workstationReq: WorkstationRequest): Promise<WorkstationResponseModel> {
        try {
            // console.log(workstationReq.workstationId)
            const workstationExists = await this.getWorkstationById(workstationReq.workstationId);
            if (workstationExists) {
                if (workstationReq.versionFlag !== workstationExists.versionFlag) {
                    throw new WorkstationResponseModel(false,10113, 'Someone updated the current Workstation  information.Refresh and try again');
                } else {
                    const workstationStatus = await this.workStationRepo.update(
                        { workstationId: workstationReq.workstationId },
                        { isActive: workstationReq.isActive, updatedUser: workstationReq.updatedUser });

                    if (workstationExists.isActive) {
                        if (workstationStatus.affected) {
                            const workstationResponse: WorkstationResponseModel = new WorkstationResponseModel(true, 10115, 'Workstation  is de-activated successfully');
                            return workstationResponse;
                        } else {
                            throw new WorkstationResponseModel(false,10111, 'Workstation is already de-activated');
                        }
                    } else {
                        if (workstationStatus.affected) {
                            const workstationResponse: WorkstationResponseModel = new WorkstationResponseModel(true, 10114, 'Workstation  is activated successfully');
                            return workstationResponse;
                        } else {
                            throw new WorkstationResponseModel(false,10112, 'Workstation  is already activated');
                        }
                    }
                }
            } else {
                throw new WorkstationResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

/**
* 
* @param unitId 
* @returns if workstation category exists
*/
    async getWorkstationById(workStationId: number): Promise<WorkStations> {
        // console.log(workStationId);
        const Response = await this.workStationRepo.findOne({
            where: { workstationId: workStationId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getAllWorkStationsForCategory(category: WorkStationCategoryRequest): Promise<WorkStationsListResponseModel> {
        try {
            // const res: WorkStationsListDto[] = [];
            // const workstations = await this.workStationRepo.getWorkStationsForCategory(category.workstationCategory, category.unitId);
            // if (workstations && workstations.length) {
            //     const workSattionsList = [];
            //     for (const res of workstations) {
            //         const workstation = res.workstation;
            //         workSattionsList.push(workstation);
            //     }
            //     const contractorWiseEmp = new WorkStationsListDto();
            //     contractorWiseEmp.workStationsData = workSattionsList;
            //     res.push(contractorWiseEmp);


                const manager = getManager()
                const dataQuery = `SELECT workstation as workstation , workstation_category_id as workstationCategory , unit_id as unitId FROM ` + appSettings.production_db + `.workstations WHERE workstation_category_id = ${category.workstationCategory} and unit_id= '${category.unitId}' ` 
                const res = await manager.query(dataQuery)
                if(res.length > 0){
                return new WorkStationsListResponseModel(true, 1111, 'Workstations Found Successfully', res);
            } else {
                throw new WorkstationResponseModel(false,9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }
    async getWorkStationsForCategory(category: WorkStationCategoryRequest): Promise<WorkStationsForCategoryResponse> {
        try {
            const workstations = await this.workStationRepo.getWorkStationsForCategory(category.workstationCategory, category.unitId);
            if (workstations && workstations.length) {
                return new WorkStationsForCategoryResponse(true, 1111, 'Workstations Found Successfully', workstations);
            } else {
                throw new WorkstationResponseModel(false,9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getWorkStationsById(inputReq: WorkstationRequest): Promise<WorkstationResponseModel> {
        // const page: number = 1;
        try {
            console.log('inputRequ');
            console.log(inputReq);
            const workstationId = inputReq.workstationId;
            const wrkStationEntity: WorkStations = await this.workStationRepo.findOne({
                where: { workstationId: workstationId, unitId: inputReq.unitId },
                relations: ['workstationCategoryInfo']
            });
            console.log(wrkStationEntity);
            let workStationData: WorkstationDTO = this.workstationAdapter.convertEntityToDto(wrkStationEntity);
            console.log('*********');
            if (workStationData) {
                console.log('999999999');
                console.log(workStationData);
                const response = new WorkstationResponseModel(true, 11101, 'Workstation retrived Successfully', workStationData);
                console.log('responseeeeeee');
                console.log(response);
                return response;
            }
            else {
                const response = new WorkstationResponseModel(false, 9999, 'something went wrong', null);
                return response;
            }
            // generating resposnse

        } catch (err) {
             return err;
        }
    }

    async getCapacityForPlantAndWorkstation(inputReq: WorkstationRequest): Promise<CommonResponse> {
        const wrkStationEntity: WorkStations = await this.workStationRepo.findOne({
            where: { workstationId: inputReq.workstationId},
            relations: ['workstationCategoryInfo']
        });
        if (!wrkStationEntity) {
            throw new WorkstationResponseModel(false,10000, 'Workstation not found');
        }
        return new CommonResponse(true, 10000, 'Workstation found', wrkStationEntity.workstationUnitCapacity);

    }




}
